'use client';

import { useEffect } from 'react';
import NextError from 'next/error';
import { captureError } from '@/utils/sentry';

class UnhandledServerComponentError extends Error {
  constructor(error: Error) {
    super(error.message, { cause: error });
    this.name = '☠️ 처리하지 않은 서버 컴포넌트 에러';
  }
}

export default function GlobalError({ error }: { error: Error & { digest?: string } }) {
  useEffect(() => {
    captureError(new UnhandledServerComponentError(error));
  }, [error]);

  return (
    <html>
      <body>
        {/* This is the default Next.js error component but it doesn't allow omitting the statusCode property yet. */}
        <NextError statusCode={undefined as any} />
      </body>
    </html>
  );
}
